// extracted by mini-css-extract-plugin
export var addButton = "_oz-0";
export var border = "_oz-8";
export var check = "_oz-h";
export var danger = "_oz-6";
export var dropdownContainer = "_oz-1";
export var editModalBody = "_oz-j";
export var footerContainer = "_oz-i";
export var fullWidth = "_oz-a";
export var hide = "_oz-9";
export var icon = "_oz-3";
export var input = "_oz-7";
export var inputFlex = "_oz-b";
export var inputWrapper = "_oz-c";
export var manualFocus = "_oz-5";
export var optionButton = "_oz-4";
export var pillWrapper = "_oz-e";
export var pointer = "_oz-2";
export var showOverflow = "_oz-f";
export var tagsFlex = "_oz-d";
export var xButton = "_oz-g";